import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }
    if (pw !== pw2) {
      toast.error("Passwords don't match.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated — please sign in.");
      navigate("/login");
    } catch (e2) {
      toast.error(formatApiErrorDetail(e2.response?.data?.detail) || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="max-w-md mx-auto px-6 py-20 text-center">
        <h1 className="font-serif-display text-3xl tracking-tight">Invalid reset link</h1>
        <p className="text-sm text-[#5F6C60] mt-4">This link is missing or malformed. Please request a new one.</p>
        <Link to="/forgot-password" className="inline-block mt-6 text-[#D97757] hover:underline">Request a reset link</Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#5F6C60] text-center">Choose a new password</div>
      <h1 className="font-serif-display text-4xl tracking-tight text-center mt-2">Reset password</h1>

      <form onSubmit={submit} className="mt-10 bg-white p-8 rounded-2xl border border-[#E8E2D6] space-y-5">
        <div>
          <Label htmlFor="pw" className="text-xs font-bold uppercase tracking-[0.15em]">New password</Label>
          <Input data-testid="reset-password" id="pw" type="password" required minLength={8} value={pw} onChange={e=>setPw(e.target.value)} className="mt-2 bg-[#F9F7F3] border-[#E8E2D6] rounded-xl h-12" />
        </div>
        <div>
          <Label htmlFor="pw2" className="text-xs font-bold uppercase tracking-[0.15em]">Confirm new password</Label>
          <Input data-testid="reset-password-confirm" id="pw2" type="password" required minLength={8} value={pw2} onChange={e=>setPw2(e.target.value)} className="mt-2 bg-[#F9F7F3] border-[#E8E2D6] rounded-xl h-12" />
        </div>
        <Button data-testid="reset-submit" disabled={loading} type="submit" className="w-full h-12 rounded-full bg-[#D97757] hover:bg-[#C26243] text-white">{loading ? "Saving…" : "Set new password"}</Button>
      </form>
    </div>
  );
}
